angular.module("ainapp")
    .controller("customerWiseSalesReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Customer Wise Sales Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {

                $('#filterModal').modal('show');
                var startdate = new Date(new Date().getFullYear(), 0, 1);


                $scope.filter = {
                    CustomerName: "",
                    ProductName: "",
                    VoucherNo: "",
                    CustomerId: "",
                    FromDate: startdate,
                    ToDate: new Date(),
                    ProductIds: [],
                    CustomerIds: [],
                }

                $scope.load = false;
                $scope.isFilter = false;

                $scope.ReportType = $stateParams.Type;
                if ($scope.ReportType == "Detail") {
                    $scope.ReportName = "Detail";
                } else if ($scope.ReportType == "Short") {
                    $scope.ReportName = "Short";
                } else {
                    $scope.ReportName = "Summary";
                }

            }
            $scope.Init();

            $scope.customerSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.CustomerInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.selectCustomerOptions = {
                placeholder: "Select Accounts...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.customerSelectDataSource
            };


            $scope.productSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.productInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.selectProductOptions = {
                placeholder: "Select Products...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.productSelectDataSource
            };




            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {



                        if ($scope.isFilter) {

                            o.data.FromDateString = $scope.extractDate($scope.filter.FromDate);
                            o.data.ToDateString = $scope.extractDate($scope.filter.ToDate);

                            o.data.CustomerId = $scope.filter.CustomerId;
                            o.data.VoucherNo = $scope.filter.VoucherNo;
                            o.data.ProductId = $scope.filter.ProductId;

                            o.data.CustomerIds = $scope.filter.CustomerIds;
                            o.data.ProductIds = $scope.filter.ProductIds;
                            o.data.CostCenters = $scope.CostCenters;

                            MainService.SalesInvoiceDetailedReport(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("NetworkError");
                            })
                        } else {
                            o.success({
                                Data: []
                            });
                        }



                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "SalesInvoice.VoucherNumber": {
                                type: "string",
                                editable: false,
                            },
                            "SalesInvoice.Date": {
                                type: "date",
                                editable: false,
                            },
                            "Product.ProductCode": {
                                type: "string",
                                editable: false,
                            },
                            "Product.Name": {
                                type: "string",
                                editable: false,
                            },
                            //                            "Product.Description": {
                            //                                type: "string",
                            //                                editable: false,
                            //                            },
                            "Unit.Name": {
                                type: "string",
                                editable: false,
                            },
                            Quantity: {
                                type: "number",
                                editable: false,
                            },
                            "SalesInvoice.Customer.Name": {
                                type: "string",
                                editable: false,
                            },

                            UnitPrice: {
                                type: "number",
                                editable: false,
                            },
                            Total: {
                                type: "number",
                                editable: false,
                            },

                            Discount: {
                                type: "number",
                                editable: false,
                            },

                            TaxableAmount: {
                                type: "number",
                                editable: false,
                            },
                            RoundOfVat: {
                                type: "number",
                                editable: false,
                            },
                            InventoryValue: {
                                type: "number",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
                group: [{
                    field: "SalesInvoice.Customer.Name",
                    aggregates: [{
                            field: "Quantity",
                            aggregate: "sum"
                    },
                        {
                            field: "Total",
                            aggregate: "sum"
                    }, {
                            field: "Discount",
                            aggregate: "sum"
                    },
                        {
                            field: "TaxableAmount",
                            aggregate: "sum"
                    },
                        {
                            field: "RoundOfVat",
                            aggregate: "sum"
                    },
                        {
                            field: "InventoryValue",
                            aggregate: "sum"
                    }]
                }],
                aggregate: [{
                        field: "Quantity",
                        aggregate: "sum"
                },
                    {
                        field: "Total",
                        aggregate: "sum"
                }, {
                        field: "Discount",
                        aggregate: "sum"
                },
                    {
                        field: "TaxableAmount",
                        aggregate: "sum"
                },
                    {
                        field: "RoundOfVat",
                        aggregate: "sum"
                },
                    {
                        field: "InventoryValue",
                        aggregate: "sum"
                }],
            });

            $scope.KendoGridOptions = {
                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "SalesInvoice.Customer.Name",
                        title: "Customer",
                        headerTemplate: $scope.LanguageData.Customer,
                        width: "220px",
                        hidden: true,
                    },
                    {
                        field: "SalesInvoice.VoucherNumber",
                        title: "Doc No #",
                        width: "120px",
                    },
                    {
                        field: "SalesInvoice.Date",
                        title: "Doc Date",
                        template: "#= kendo.toString(kendo.parseDate(SalesInvoice.Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: "120px",


                        //                        headerTemplate: $scope.LanguageData.date,
                    },


                    {
                        field: "Product.ProductCode",
                        title: "Code",
                        width: "120px",

                    },

                    {
                        field: "Product.Name",
                        title: "Product",
                        width: "200px",

                    },

                    {
                        field: "Unit.Name",
                        title: "UOM",
                        width: "100px",

                    },


                    {
                        field: "Quantity",
                        title: "Qty",
                        width: "100px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        groupFooterTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Quantity, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Quantity</div>"),
                        groupFooterTemplate: "#=sum#",
                    },
                    {
                        field: "UnitPrice",
                        title: "Unit Price",
                        width: "110px",
                        template: "<div style='text-align: right'>#=kendo.toString(UnitPrice, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>Unit Price</div>")

                    },
                    {
                        field: "Total",
                        title: "Value",
                        width: "120px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        groupFooterTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Total, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=sum#",
                        headerTemplate: kendo.template("<div class='headerright'>Value</div>")
                    },

                    {
                        field: "Discount",
                        title: "Discount",
                        width: "120px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        groupFooterTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Discount, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=sum#",
                        headerTemplate: kendo.template("<div class='headerright'>Discount</div>")
                    },

                    {
                        field: "TaxableAmount",
                        title: "Taxable Amount",
                        width: "160px",
                        aggregates: ["sum"],
                        //footerTemplate: "#=sum#",
                        groupFooterTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(TaxableAmount, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=sum#",
                        headerTemplate: kendo.template("<div class='headerright'>Taxable Amount</div>")
                    },

                    {
                        field: "RoundOfVat",
                        title: "VAT Amount",
                        width: "150px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        groupFooterTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(RoundOfVat, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=sum#",
                        headerTemplate: kendo.template("<div class='headerright'>VAT Amount</div>")
                    },

                    {
                        field: "InventoryValue",
                        title: "Inventory Value",
                        width: "160px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        groupFooterTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(InventoryValue, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=sum#",
                        headerTemplate: kendo.template("<div class='headerright'>Inventory Value</div>")
                    },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-eye'  ng-click='View(dataItem)'></button> <button class=' btn-default btn-sm fa fa-print'  ng-click='PrintInvoice(dataItem.SalesInvoice.Id, \"Sales Invoice\",dataItem.SalesInvoice.VoucherNumber)'></button>",
                        sticky: true,
                        width: '100px'
                    },



                ],
            };


            $scope.KendoSource2 = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        if ($scope.isFilter) {

                            o.data.FromDateString = $scope.extractDate($scope.filter.FromDate);
                            o.data.ToDateString = $scope.extractDate($scope.filter.ToDate);

                            o.data.CustomerId = $scope.filter.CustomerId;
                            o.data.VoucherNo = $scope.filter.VoucherNo;
                            o.data.ProductId = $scope.filter.ProductId;

                            o.data.CustomerIds = $scope.filter.CustomerIds;
                            o.data.ProductIds = $scope.filter.ProductIds;
                            o.data.CostCenters = $scope.CostCenters;


                            MainService.SalesInvoiceSummaryReport(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("NetworkError");
                            })
                        } else {
                            o.success({
                                Data: []
                            });
                        }


                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "VoucherNumber": {
                                type: "string",
                                editable: false,
                            },
                            "Date": {
                                type: "date",
                                editable: false,
                            },
                            "Customer.Name": {
                                type: "string",
                                editable: false,
                            },
                            "BaseCurrency.Name": {
                                type: "string",
                                editable: false,
                            },

                            NetTotal: {
                                type: "number",
                                editable: false,
                            },
                            GrossTotal: {
                                type: "number",
                                editable: false,
                            },
                            TotalDiscount: {
                                type: "number",
                                editable: false,
                            },
                            TotalOtherCharges: {
                                type: "number",
                                editable: false,
                            },
                            TotalExtraCharges: {
                                type: "number",
                                editable: false,
                            },
                            TotalTax: {
                                type: "number",
                                editable: false,
                            },
                            GrandTotal: {
                                type: "number",
                                editable: false,
                            },
                            LinkedRefNos: {
                                type: "number",
                                editable: false,
                            },
                            Remarks: {
                                type: "string",
                                editable: false,
                            },
                            CalcGrandTotal: {
                                type: "float",
                            },
                            ConversionRate: {
                                type: "float",
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
                group: [{
                    field: "Customer.Name",
                    aggregates: [{
                            field: "GrossTotal",
                            aggregate: "sum"
                },
                        {
                            field: "NetTotal",
                            aggregate: "sum"
                }, {
                            field: "TotalDiscount",
                            aggregate: "sum"
                },
                        {
                            field: "TotalOtherCharges",
                            aggregate: "sum"
                },
                        {
                            field: "TotalExtraCharges",
                            aggregate: "sum"
                },
                        {
                            field: "TotalTax",
                            aggregate: "sum"
                },
                        {
                            field: "GrandTotal",
                            aggregate: "sum"
                },
                        {
                            field: "CalcGrandTotal",
                            aggregate: "sum"
                }]
                }],
                aggregate: [{
                        field: "GrossTotal",
                        aggregate: "sum"
                },
                    {
                        field: "NetTotal",
                        aggregate: "sum"
                }, {
                        field: "TotalDiscount",
                        aggregate: "sum"
                },
                    {
                        field: "TotalOtherCharges",
                        aggregate: "sum"
                },
                    {
                        field: "TotalExtraCharges",
                        aggregate: "sum"
                },
                    {
                        field: "TotalTax",
                        aggregate: "sum"
                },
                    {
                        field: "GrandTotal",
                        aggregate: "sum"
                },
                    {
                        field: "CalcGrandTotal",
                        aggregate: "sum"
                }
                ],

            });

            $scope.KendoGridOptions2 = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource2,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },


                columns: [


                    {
                        field: "VoucherNumber",
                        title: "Doc No #",
                        width: "120px",
                    },
                    {
                        field: "Date",
                        title: "Doc Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: "120px",
                    },
                    {
                        field: "Customer.Name",
                        title: "Customer",
                        headerTemplate: $scope.LanguageData.Customer,
                        width: "200px",
                    },
                    {
                        field: "BaseCurrency.Name.Name",
                        title: "Currency",
                        headerTemplate: $scope.LanguageData.Currency,
                        width: "100px",
                    },
                    {
                        field: "LinkedRefNos",
                        title: "Linked Refs",
                        width: "150px",
                    },
                    {
                        field: "GrossTotal",
                        title: "Gross",
                        width: "100px",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(GrossTotal, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Gross</div>"),
                        groupFooterTemplate: "#=sum#",
                    },
                    {
                        field: "TotalDiscount",
                        title: "Disc",
                        width: "100px",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(TotalDiscount, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Disc</div>"),
                        groupFooterTemplate: "#=sum#",
                    },

                    {
                        field: "TotalOtherCharges",
                        title: "Other CH",
                        width: "100px",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(TotalOtherCharges, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Other CH</div>"),
                        groupFooterTemplate: "#=sum#",
                    },
                    {
                        field: "NetTotal",
                        title: "Net",
                        width: "100px",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(NetTotal, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Net</div>"),
                        groupFooterTemplate: "#=sum#",
                    },
                    {
                        field: "TotalTax",
                        title: "Tax",
                        width: "100px",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(TotalTax, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Tax</div>"),
                        groupFooterTemplate: "#=sum#",
                    },
                    {
                        field: "TotalExtraCharges",
                        title: "Extra CH",
                        width: "100px",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(TotalExtraCharges, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Extra CH</div>"),
                        groupFooterTemplate: "#=sum#",
                    },

                    {
                        field: "GrandTotal",
                        title: "Total",
                        width: "100px",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(GrandTotal, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Total</div>"),
                        groupFooterTemplate: "#=sum#",
                    },
                    {
                        field: "ConversionRate",
                        title: "Conversion Rate",
                        width: "100px",
                        template: "<div style='text-align: right'>#=kendo.toString(ConversionRate, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>Conversion Rate</div>")
                    },
                    {
                        field: "CalcGrandTotal",
                        title: "Calc Total",
                        width: "100px",
                        aggregates: ["sum"],
                        template: "<div style='text-align: right'>#=kendo.toString(CalcGrandTotal, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Calc Total</div>"),
                        groupFooterTemplate: "#=sum#",
                    },
                    {
                        field: "Remarks",
                        title: "Remarks",
                        width: "220px",
                    },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-eye'  ng-click='View(dataItem)'></button> <button class=' btn-default btn-sm fa fa-print'  ng-click='PrintInvoice(dataItem.Id, \"Sales Invoice\",dataItem.VoucherNumber)'></button>",
                        width: '100px',
                        sticky: true
                    },


                ],
            };


            $scope.KendoSource3 = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {



                        if ($scope.isFilter) {


                            o.data.FromDateString = $scope.extractDate($scope.filter.FromDate);
                            o.data.ToDateString = $scope.extractDate($scope.filter.ToDate);

                            o.data.CustomerId = $scope.filter.CustomerId;
                            o.data.VoucherNo = $scope.filter.VoucherNo;
                            o.data.ProductId = $scope.filter.ProductId;

                            o.data.CustomerIds = $scope.filter.CustomerIds;
                            o.data.ProductIds = $scope.filter.ProductIds;
                            o.data.CostCenters = $scope.CostCenters;

                            MainService.SalesInvoiceDetailedReport(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("NetworkError");
                            })
                        } else {
                            o.success({
                                Data: []
                            });
                        }



                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "SalesInvoice.VoucherNumber": {
                                type: "string",
                                editable: false,
                            },
                            "SalesInvoice.Date": {
                                type: "date",
                                editable: false,
                            },
                            "Product.ProductCode": {
                                type: "string",
                                editable: false,
                            },
                            "Product.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Product.ProductCode": {
                                type: "string",
                                editable: false,
                            },
                            //                            "Product.Description": {
                            //                                type: "string",
                            //                                editable: false,
                            //                            },
                            "Unit.Name": {
                                type: "string",
                                editable: false,
                            },
                            Quantity: {
                                type: "number",
                                editable: false,
                            },
                            "SalesInvoice.Customer.Name": {
                                type: "string",
                                editable: false,
                            },
                            "SalesInvoice.Customer.AccountCode": {
                                type: "string",
                                editable: false,
                            },

                            UnitPrice: {
                                type: "number",
                                editable: false,
                            },
                            Total: {
                                type: "number",
                                editable: false,
                            },

                            Discount: {
                                type: "number",
                                editable: false,
                            },

                            TaxableAmount: {
                                type: "number",
                                editable: false,
                            },
                            RoundOfVat: {
                                type: "number",
                                editable: false,
                            },
                            InventoryValue: {
                                type: "number",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
                group: [{
                    field: "SalesInvoice.Customer.Name",
                    aggregates: [{
                            field: "Quantity",
                            aggregate: "sum"
                    },
                        {
                            field: "Total",
                            aggregate: "sum"
                    }, {
                            field: "UnitPrice",
                            aggregate: "sum"
                    },
                        ]
                }],
                aggregate: [{
                        field: "Quantity",
                        aggregate: "sum"
                },
                    {
                        field: "Total",
                        aggregate: "sum"
                }, {
                        field: "UnitPrice",
                        aggregate: "sum"
                }],
            });

            $scope.KendoGridOptions3 = {
                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource3,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                    {
                        field: "SalesInvoice.Customer.Name",
                        title: "Customer",
                        headerTemplate: $scope.LanguageData.Customer,
                        width: "220px",
                        hidden: true,
                    },
                    {
                        field: "Product.ProductCode",
                        title: "Code",
                        width: "120px",

                    },
                    {
                        field: "Product.Name",
                        title: "Product",
                        width: "200px",

                    },

                    {
                        field: "Quantity",
                        title: "Qty",
                        width: "100px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        groupFooterTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Quantity, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Quantity</div>"),
                        groupFooterTemplate: "#=sum#",
                    },
                    {
                        field: "Total",
                        title: "Value",
                        width: "120px",
                        aggregates: ["sum"],
                        // footerTemplate: "#=sum#",
                        groupFooterTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(Total, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=sum#",
                        headerTemplate: kendo.template("<div class='headerright'>Value</div>")
                    },
                    {
                        field: "UnitPrice",
                        title: "Average Price",
                        width: "110px",
                        template: "<div style='text-align: right'>#=kendo.toString(UnitPrice, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=sum#",
                        headerTemplate: kendo.template("<div class='headerright'>Average Price</div>")

                    },
                ],
            };




            //            $scope.Edit = function (data) {
            //                $state.go("editSalesInvoice", {
            //                    VoucherId: data.SalesInvoice.Id
            //                })
            //            }
            //
            //            $scope.View = function (data) {
            //                $state.go("viewSalesInvoice", {
            //                    VoucherId: data.SalesInvoice.Id
            //                })
            //            }



            $scope.Edit = function (data) {
                if ($scope.ReportType == "Detail") {
                    $state.go("editSalesInvoice", {
                        VoucherId: data.SalesInvoice.Id
                    })
                } else {
                    $state.go("editSalesInvoice", {
                        VoucherId: data.Id
                    })
                }
            }

            $scope.View = function (data) {
                if ($scope.ReportType == "Detail") {
                    $state.go("viewSalesInvoice", {
                        VoucherId: data.SalesInvoice.Id
                    })
                } else {
                    $state.go("viewSalesInvoice", {
                        VoucherId: data.Id
                    })
                }
            }

            $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.GetReport = function () {
                $scope.isFilter = true;
                $('#filterModal').modal('hide');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.Refresh = function () {
                $scope.Init();
                $scope.isFilter = true;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.print = function () {

                $scope.filter.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                $scope.filter.FromDay = $scope.filter.FromDate.getDate();
                $scope.filter.FromYear = $scope.filter.FromDate.getFullYear();

                $scope.filter.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                $scope.filter.ToDay = $scope.filter.ToDate.getDate();
                $scope.filter.ToYear = $scope.filter.ToDate.getFullYear();

                $scope.filter.CostCenters = $scope.CostCenters;

                MainService.PrintSalesInvoiceReport($scope.filter).then(function (response) {
                    if (response.data != null) {
                        $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.Load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                })
            }


        }])
